﻿import { Component, OnInit} from '@angular/core';
import { RestService } from 'src/app/_services/rest.service';
import { ActivatedRoute } from '@angular/router';


@Component({ templateUrl: 'puntos.component.html' })
export class PuntosComponent implements OnInit {

    data: any;

    anio: any;

    constructor(private restService: RestService, private route: ActivatedRoute) {
        this.route.queryParams.subscribe(params => {
            if (params['anio']) {
                this.anio = JSON.parse(params['anio']);
            } else {
                this.anio = this.currentYear();
            }
            this.loadAll();
        });
    }


    ngOnInit() {
    }

    loadAll() {
        this.restService.getAll('/rest-api/user/resultado/puntos?anio=' + this.anio).subscribe(data => {
            this.data = data;
        });
    }



    currentYear(): number {
        return (new Date()).getFullYear();
    }



}
